<template>
<div>
  <div class="text-center">
    <button v-b-modal.modal-user-activate class="btn btn-outline-success btn-rounded" type="button">
      Activate Account<i class="fas fa-user-check"></i>
    </button>
  </div>
  <b-modal id="modal-user-activate" cancel-variant="danger" ok-title="Activate" ok-variant="success"
        :title="`Activate ${user.first_name} ${user.last_name}'s Account?`" @ok="activateAccount">
      <p>
        {{user.first_name}} will be able to perform all the operations assigned to their role.
        Kindly ensure you have verified their details appropriately.
      </p>
  </b-modal>
</div>
</template>

<script>
import axios from "axios";
import {unverified_users} from "@/utils/api_paths";
import {handleError, secureStoreGetAuthString, showFlashMessage, startLoader} from "@/utils/util_functions";

export default {
  name: "VerifyUserDetails",
  props: {
    user: {required: true}
  },

  methods: {
    activateAccount(){
      let loader = startLoader(this)

      axios.put(unverified_users, {
        role: this.user.role,
        email: this.user.email,
        is_active: JSON.stringify(true)
      }, {
        headers:
            {
              Authorization: secureStoreGetAuthString()
            }
      }).then((response) => {
        setTimeout(() => {
            loader.hide()
            showFlashMessage(this, 'success', 'User Activated', response.data.message);
        }, 2000)
      }).catch((error) => {
            handleError(this, error, loader)
      })
    }
  }
}
</script>
